import * as PATHS from '../common/urlConstants';

export const PATH_PERMISSIONS = [
  {
    /********** 유저 리스트 페이지 접근 권한 **********/
    path: PATHS.ACCOUNT_USER_LIST_URL_PATH,
    resource: 'user',
    permissions: ['readList'],
  },
  {
    /********** 유저 랭크 페이지 접근 권한 **********/
    path: PATHS.ACCOUNT_USER_RANK_URL_PATH,
    resource: 'userRank',
    permissions: ['readList'],
  },
  {
    /********** 유저 상세 페이지 접근 권한 **********/
    path: PATHS.ACCOUNT_USER_DETAIL_URL_PATH,
    resource: 'user',
    permissions: ['read'],
  },
  {
    /********** 판매자 리스트 페이지 접근 권한 **********/
    path: PATHS.ACCOUNT_SELLER_LIST_URL_PATH,
    resource: 'seller',
    permissions: ['readList'],
  },
  {
    /********** 입점승인 판매점 페이지 접근 권한 **********/
    path: PATHS.BRAND_JOIN_LIST_URL_PATH,
    resource: 'store',
    permissions: ['readList'],
  },
  {
    /********** 스토어 리스트 페이지 접근 권한 **********/
    path: PATHS.BRAND_ALL_LIST_URL_PATH,
    resource: 'store',
    permissions: ['readList'],
  },
  {
    /********** 브랜드 태그 검수 리스트 페이지 접근 권한 **********/
    path: PATHS.BRAND_TAG_REQUEST_LIST_URL_PATH,
    resource: 'store',
    permissions: ['readList'],
  },
  {
    /********** 브랜드 상세 페이지 접근 권한 **********/
    path: PATHS.BRAND_DETAIL_URL_PATH,
    resource: 'store',
    permissions: ['read'],
  },
  {
    /********** 브랜드 티어 관리 페이지 접근 권한 **********/
    path: PATHS.BRAND_TIER_URL_PATH,
    resource: 'storeTier',
    permissions: ['readList', 'update'],
  },
  {
    /********** 브랜드 상단 노출 관리 페이지 접근 권한 **********/
    path: PATHS.BRAND_TOP_EXPOSURE_URL_PATH,
    resource: 'storeExpose',
    permissions: ['readList'],
  },
  {
    /********** 브랜드 노출 순서 관리 페이지 접근 권한 **********/
    path: PATHS.BRAND_EXPOSURE_URL_PATH,
    resource: 'storeExpose',
    permissions: ['readList'],
  },
  {
    /********** 싱픔 전체 리스트 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_ALL_LIST_URL_PATH,
    resource: 'product',
    permissions: ['readList'],
  },
  {
    /********** 상품 승인 리스트 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_APPROVAL_LIST_URL_PATH,
    resource: 'product',
    permissions: ['readList'],
  },
  {
    /********** 상품 금지 리스트 페이지 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_BAN_LIST_URL_PATH,
    resource: 'product',
    permissions: ['readList'],
  },
  {
    /********** 상품 속성 검수 리스트 페이지접근 권한 **********/
    path: PATHS.PRODUCT_PROPERTY_REQUEST_LIST_URL_PATH,
    resource: 'product',
    permissions: ['readList'],
  },
  {
    /********** 상품 등록 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_CREATE_URL_PATH,
    resource: 'product',
    permissions: ['create'],
  },
  {
    /********** 상품 벌크 편집 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_BULK_EDIT_URL_PATH,
    resource: 'product',
    permissions: ['update'],
  },
  {
    /********** 상품 편집 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_EDIT_URL_PATH,
    resource: 'product',
    permissions: ['update'],
  },
  {
    /********** 상품 상세 페이지 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_DETAIL_URL_PATH,
    resource: 'product',
    permissions: ['read'],
  },
  {
    /********** 상품 복사 페이지 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_COPY_URL_PATH,
    resource: 'product',
    permissions: ['create'],
  },
  {
    /********** 상품 버전 페이지 페이지 접근 권한 **********/
    path: PATHS.PRODUCT_VERSION_URL_PATH,
    resource: 'product',
    permissions: ['read'],
  },
  {
    /********** 주문 전체 리스트 페이지 접근 권한 **********/
    path: PATHS.ORDER_ALL_LIST_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 주문 취소 리스트 페이지 접근 권한 **********/
    path: PATHS.ORDER_CANCEL_LIST_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 주문 반품 리스트 페이지 접근 권한 **********/
    path: PATHS.ORDER_RETURN_LIST_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 주문 교환 리스트 페이지 접근 권한 **********/
    path: PATHS.ORDER_EXCHANGE_LIST_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 주문/배송관리 페이지 접근 권한 **********/
    path: PATHS.ORDER_MANAGEMENT_LIST_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 취소관리 페이지 페이지 접근 권한 **********/
    path: PATHS.ORDER_CANCEL_MANAGEMENT_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 반품관리 페이지 접근 권한 **********/
    path: PATHS.ORDER_RETURN_MANAGEMENT_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 교환관리 페이지 접근 권한 **********/
    path: PATHS.ORDER_EXCHANGE_MANAGEMENT_URL_PATH,
    resource: 'order',
    permissions: ['readList'],
  },
  {
    /********** 주문 상세 페이지 접근 권한 **********/
    path: PATHS.ORDER_DETAIL_URL_PATH,
    resource: 'order',
    permissions: ['read'],
  },
  {
    /********** 주문 반품 상세 페이지 **********/
    path: PATHS.ORDER_RETURN_DETAIL_URL_PATH,
    resource: 'orderReturn',
    permissions: ['read'],
  },
  {
    /********** 멀티 채널 주문 관리 페이지 접근 권한 **********/
    path: PATHS.MULTI_CHANNEL_ORDER_MANAGEMENT_URL_PATH,
    resource: 'multiChannelOrderItem',
    permissions: ['readList'],
  },
  {
    /********** 멀티 채널 주문 생성 페이지 접근 권한 **********/
    path: PATHS.MULTI_CHANNEL_ORDER_CREATE_URL_PATH,
    resource: 'multiChannelOrderItem',
    permissions: ['create'],
  },
  {
    /********** 정산 대기 목록 페이지 접근 권한 **********/
    path: PATHS.BALANCE_WAITING_LIST_URL_PATH,
    resource: 'balance',
    permissions: ['readList'],
  },
  {
    /********** 정산 완료 목록 페이지 접근 권한 **********/
    path: PATHS.BALANCE_DONE_LIST_URL_PATH,
    resource: 'balance',
    permissions: ['readList'],
  },
  {
    /********** 정산 보류 목록 페이지 접근 권한 **********/
    path: PATHS.BALANCE_HOLD_LIST_URL_PATH,
    resource: 'balance',
    permissions: ['readList'],
  },
  {
    /********** 정산 상세 페이지접근 권한 **********/
    path: PATHS.BALANCE_EXECUTION_URL_PATH,
    resource: 'balance',
    permissions: ['read'],
  },
  {
    /********** 브랜드별 정산 타입 목록 접근 권한 **********/
    path: PATHS.BALANCE_BRAND_LIST_URL_PATH,
    resource: 'storeBalance',
    permissions: ['readList'],
  },
  {
    /********** 정산 기준일 변경 페이지 접근 권한 **********/
    path: PATHS.BALANCE_ADJUSTMENT_BASE_DATE_URL_PATH,
    resource: 'settlementDateAdjustment',
    permissions: ['readList'],
  },
  {
    /********** 정산 완료일 변경 페이지 접근 권한 **********/
    path: PATHS.BALANCE_ADJUSTMENT_COMPLETE_DATE_URL_PATH,
    resource: 'settlementCompleteDateAdjustment',
    permissions: ['readList'],
  },
  {
    /********** 결제 PG 라우팅 페이지 접근 권한 **********/
    path: PATHS.PAYMENT_PG_ROUTE_URL_PATH,
    resource: 'paymentPgRoute',
    permissions: ['read'],
  },
  {
    /********** PG 수수료 관리 페이지 접근 권한 **********/
    path: PATHS.PAYMENT_PG_FEE_URL_PATH,
    resource: 'paymentPgFee',
    permissions: ['read'],
  },
  {
    /********** 태그 등록 페이지 접근 권한 **********/
    path: PATHS.TAG_CREATE_URL_PATH,
    resource: 'tag',
    permissions: ['create'],
  },
  {
    /********** 태그 편집 페이지 URL PATH **********/
    path: PATHS.TAG_EDIT_URL_PATH,
    resource: 'tag',
    permissions: ['update'],
  },
  {
    /********** 태그 상세 내역 페이지 접근 권한 **********/
    path: PATHS.TAG_HISTORY_URL_PATH,
    resource: 'tag',
    permissions: ['read'],
  },
  {
    /********** 태그 리스트 페이지 접근 권한 **********/
    path: PATHS.TAG_LIST_URL_PATH,
    resource: 'tag',
    permissions: ['readList'],
  },
  {
    /********** 태그 그룹 등록 페이지 접근 권한 **********/
    path: PATHS.TAG_GROUP_CREATE_URL_PATH,
    resource: 'tagGroup',
    permissions: ['create'],
  },
  {
    /********** 태그 그룹 편집 페이지 접근 권한 **********/
    path: PATHS.TAG_GROUP_EDIT_URL_PATH,
    resource: 'tagGroup',
    permissions: ['read', 'update'],
  },
  {
    /********** 태그 그룹 리스트 페이지 접근 권한 **********/
    path: PATHS.TAG_GROUP_LIST_URL_PATH,
    resource: 'tagGroup',
    permissions: ['readList'],
  },
  {
    /********** 태그 탭 메인 관리 페이지 페이지 접근 권한 **********/
    path: PATHS.TAG_TAB_MAIN_MANAGEMENT_URL_PATH,
    resource: 'tagTabMain',
    permissions: ['read', 'update'],
  },
  {
    /********** 태그 트렌드 키워드 관리 페이지 접근 권한 **********/
    path: PATHS.TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH,
    resource: 'tagTrendKeyword',
    permissions: ['read', 'update'],
  },
  {
    /********** 프로모션 타임라인 페이지 접근 권한 **********/
    path: PATHS.PROMOTION_SCHEDULE_URL_PATH,
    resource: 'promotionSchedule',
    permissions: ['readList'],
  },
  {
    /**
     * 프로모션 리스트 페이지 접근 권한
     *
     * ⚠️ **반드시 상세(`:id`)보다 위에 둔다.** 이 목록은 `find` 로 **처음 걸리는 항목**을 쓰는데,
     * 상세 경로의 `:id` 가 `.+` 로 치환돼 `/promotion/schedule/list` 까지 잡는다.
     * 순서가 뒤집히면 리스트가 상세의 권한 규칙으로 판정된다.
     */
    path: PATHS.PROMOTION_SCHEDULE_LIST_URL_PATH,
    resource: 'promotionSchedule',
    permissions: ['readList'],
  },
  {
    /**
     * 프로모션 상세 페이지 접근 권한
     *
     * 타임라인·리스트와 **같은 `readList`** 다 — 상세 전용 권한을 두지 않는다.
     * 백엔드 `GET /promotion-schedules/:id` 도 `Action.ReadList` 로 막으므로,
     * 여기만 `read` 로 두면 화면은 열리는데 API 가 403 이 된다.
     */
    path: PATHS.PROMOTION_SCHEDULE_DETAIL_URL_PATH,
    resource: 'promotionSchedule',
    permissions: ['readList'],
  },
  {
    /********** 홈에 노출중인 기획전 리스트 페이지 접근 권한 **********/
    path: PATHS.EVENT_IN_PROGRESS_LIST_URL_PATH,
    resource: 'event',
    permissions: ['readList'],
  },
  {
    /********** 기획전 전체 리스트 페이지  접근 권한 **********/
    path: PATHS.EVENT_ALL_LIST_URL_PATH,
    resource: 'event',
    permissions: ['readList'],
  },
  {
    /********** 기획전 등록 페이지 접근 권한 **********/
    path: PATHS.EVENT_CREATE_URL_PATH,
    resource: 'event',
    permissions: ['create'],
  },
  {
    /********** 기획전 편집 페이지 접근 권한 **********/
    path: PATHS.EVENT_EDIT_URL_PATH,
    resource: 'event',
    permissions: ['read', 'update'],
  },
  {
    /********** 쿠폰 리스트 페이지 접근 권한 **********/
    path: PATHS.COUPON_LIST_URL_PATH,
    resource: 'coupon',
    permissions: ['readList'],
  },
  {
    /********** 쿠폰 발급 페이지 접근 권한 **********/
    path: PATHS.COUPON_GENERATE_URL_PATH,
    resource: 'coupon',
    permissions: ['create'],
  },
  {
    /********** 쿠폰 발급 내역 리스트 페이지 접근 권한 **********/
    path: PATHS.COUPON_ISSUE_HISTORY_LIST_URL_PATH,
    resource: 'coupon',
    permissions: ['readList'],
  },
  {
    /********** 쿠폰 발급 내역 상세 페이지 접근 권한 **********/
    path: PATHS.COUPON_ISSUE_HISTORY_DETAIL_URL_PATH,
    resource: 'coupon',
    permissions: ['read'],
  },
  {
    /********** 쿠폰 편집 페이지 접근 권한 **********/
    path: PATHS.COUPON_EDIT_URL_PATH,
    resource: 'coupon',
    permissions: ['update'],
  },
  {
    /********** 쿠폰 복사 페이지 접근 권한 **********/
    path: PATHS.COUPON_COPY_URL_PATH,
    resource: 'coupon',
    permissions: ['create'],
  },
  {
    /********** 쿠폰 상세 페이지 접근 권한 **********/
    path: PATHS.COUPON_DETAIL_URL_PATH,
    resource: 'coupon',
    permissions: ['read'],
  },
  {
    /********** 쿠폰 등록 페이지 접근 권한 **********/
    path: PATHS.COUPON_CREATE_URL_PATH,
    resource: 'coupon',
    permissions: ['create'],
  },
  {
    /**********
     * 알림톡 발송 등록 페이지 접근 권한
     * 라우트 가드는 단일 리소스만 검사하지만, 페이지가 실제로 쓰는 API 권한은 세트다 —
     * 부여 시 alimtalkSendSchedule(create·read〈preview〉) + alimtalkTemplate(read·readList)을 함께 줄 것.
     **********/
    path: PATHS.ALIMTALK_SEND_CREATE_URL_PATH,
    resource: 'alimtalkSendSchedule',
    permissions: ['create'],
  },
  {
    /********** 알림톡 발송 내역 리스트 페이지 접근 권한 **********/
    path: PATHS.ALIMTALK_SEND_HISTORY_LIST_URL_PATH,
    resource: 'alimtalkSendSchedule',
    permissions: ['readList'],
  },
  {
    /********** 알림톡 발송 내역 상세 페이지 접근 권한 **********/
    path: PATHS.ALIMTALK_SEND_HISTORY_DETAIL_URL_PATH,
    resource: 'alimtalkSendSchedule',
    permissions: ['read'],
  },
  {
    /********** 포인트 내역 리스트 페이지 접근 권한 **********/
    path: PATHS.POINT_LIST_URL_PATH,
    resource: 'point',
    permissions: ['readList'],
  },
  {
    /********** 포인트 발급 페이지 접근 권한 **********/
    path: PATHS.POINT_GENERATE_URL_PATH,
    resource: 'point',
    permissions: ['create'],
  },
  {
    /********** 포인트 발급 내역 리스트 페이지 접근 권한 **********/
    path: PATHS.POINT_ISSUE_HISTORY_LIST_URL_PATH,
    resource: 'point',
    permissions: ['readList'],
  },
  {
    /********** 포인트 발급 내역 상세 페이지 접근 권한 **********/
    path: PATHS.POINT_ISSUE_HISTORY_DETAIL_URL_PATH,
    resource: 'point',
    permissions: ['read'],
  },
  {
    /********** 포인트 랭킹 페이지 접근 권한 **********/
    path: PATHS.POINT_RANKING_LIST_URL_PATH,
    resource: 'point',
    permissions: ['readList'],
  },
  {
    /********** 포인트 레퍼럴 발급 현황 페이지 접근 권한 **********/
    path: PATHS.POINT_REFERRAL_ISSUE_LIST_URL_PATH,
    resource: 'point',
    permissions: ['readList'],
  },
  {
    /********** 포인트 사유 리스트 페이지 접근 권한 **********/
    path: PATHS.POINT_CAUSE_LIST_URL_PATH,
    resource: 'point',
    permissions: ['readList'],
  },
  {
    /********** 포인트 사유 등록 등록 페이지 접근 권한 **********/
    path: PATHS.POINT_CAUSE_CREATE_URL_PATH,
    resource: 'point',
    permissions: ['create'],
  },
  {
    /********** 메인 페이지 관리 페이지 접근 권한 **********/
    path: PATHS.MAIN_TAB_MANAGEMENT_URL_PATH,
    resource: 'mainPage',
    permissions: ['readList', 'update'],
  },
  {
    /********** 메인 페이지 관리 페이지 접근 권한 **********/
    path: PATHS.MAIN_PAGE_MANAGEMENT_URL_PATH,
    resource: 'mainPage',
    permissions: ['readList', 'update'],
  },
  {
    /********** 서브 페이지 리스트 페이지 접근 권한 **********/
    path: PATHS.SUB_PAGE_LIST_URL_PATH,
    resource: 'subPage',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 서브 페이지 등록 페이지 접근 권한 **********/
    path: PATHS.SUB_PAGE_CREATE_URL_PATH,
    resource: 'subPage',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 서브 페이지 관리 페이지  접근 권한 **********/
    path: PATHS.SUB_PAGE_MANAGEMENT_URL_PATH,
    resource: 'subPage',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 서브 페이지 편집 페이지 접근 권한 **********/
    path: PATHS.SUB_PAGE_EDIT_URL_PATH,
    resource: 'subPage',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 위젯 전체 리스트 페이지 편집 페이지 접근 권한 **********/
    path: PATHS.WIDGET_ALL_LIST_URL_PATH,
    resource: 'widget',
    permissions: ['readList'],
  },
  {
    /********** 메뉴 등록 및 편집 페이지 접근 권한 **********/
    path: PATHS.WIDGET_HOME_MENU_CREATE_URL_PATH,
    resource: 'menu',
    permissions: ['update', 'readList'],
  },
  {
    /********** 위젯 생성 페이지 접근 권한 **********/
    path: PATHS.WIDGET_CREATE_URL_PATH,
    resource: 'widget',
    permissions: ['create'],
  },
  {
    /********** 위젯 편집 페이지 접근 권한 **********/
    path: PATHS.WIDGET_EDIT_URL_PATH,
    resource: 'widget',
    permissions: ['read', 'update'],
  },
  {
    /********** 위젯 WIDGET_COPY_URL_PATH 페이지 접근 권한 **********/
    path: PATHS.WIDGET_COPY_URL_PATH,
    resource: 'widget',
    permissions: ['create'],
  },
  {
    /********** 카테고리 전시 관리 페이지 접근 권한 **********/
    path: PATHS.CATEGORY_EXHIBIT_MANAGEMENT_URL_PATH,
    resource: 'productCategoryExhibition',
    permissions: ['readList', 'update'],
  },
  {
    /********** 카테고리 상세 페이지  접근 권한 **********/
    path: PATHS.CATEGORY_DETAIL_URL_PATH,
    resource: 'productCategory',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 카테고리 생성 페이지접근 권한 **********/
    path: PATHS.CATEGORY_CREATE_URL_PATH,
    resource: 'productCategory',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 카테고리 생성 관리 페이지 접근 권한 **********/
    path: PATHS.CATEGORY_CREATE_MANAGEMENT_URL_PATH,
    resource: 'productCategory',
    permissions: ['readList', 'read', 'create', 'update', 'delete'],
  },
  {
    /********** 스플래시 이미지 리스트 페이지 접근 권한 **********/
    path: PATHS.REMOTE_SPLASH_IMAGE_LIST_URL_PATH,
    resource: 'remoteSplashImage',
    permissions: ['readList'],
  },
  {
    /**********  스플래시 이미지 등록 페이지 접근 권한 **********/
    path: PATHS.REMOTE_SPLASH_IMAGE_CREATE_URL_PATH,
    resource: 'remoteSplashImage',
    permissions: ['create'],
  },
  {
    /********** 스플래시 이미지 수정 페이지 접근 권한 **********/
    path: PATHS.REMOTE_SPLASH_IMAGE_EDIT_URL_PATH,
    resource: 'remoteSplashImage',
    permissions: ['read', 'update'],
  },
  {
    /********** 레퍼럴 이미지 리스트 페이지 접근 권한 **********/
    path: PATHS.REMOTE_REFERRAL_IMAGE_LIST_URL_PATH,
    resource: 'remoteReferralImage',
    permissions: ['readList'],
  },
  {
    /********** 레퍼럴 이미지 등록 페이지 접근 권한 **********/
    path: PATHS.REMOTE_REFERRAL_IMAGE_CREATE_URL_PATH,
    resource: 'remoteReferralImage',
    permissions: ['create'],
  },
  {
    /********** 레퍼럴 이미지 수정 페이지 접근 권한 **********/
    path: PATHS.REMOTE_REFERRAL_IMAGE_EDIT_URL_PATH,
    resource: 'remoteReferralImage',
    permissions: ['read', 'update'],
  },
  {
    /********** 상점 공지사항 리스트 페이지 접근 권한 **********/
    path: PATHS.NOTICE_STORE_LIST_URL_PATH,
    resource: 'storeNotice',
    permissions: ['readList'],
  },
  {
    /********** 상점 공지사항 등록 페이지 접근 권한 **********/
    path: PATHS.NOTICE_STORE_CREATE_URL_PATH,
    resource: 'storeNotice',
    permissions: ['create'],
  },
  {
    /********** 상점 공지사항 편집 페이지 접근 권한 **********/
    path: PATHS.NOTICE_STORE_EDIT_URL_PATH,
    resource: 'storeNotice',
    permissions: ['read', 'update'],
  },
  {
    /**********상품 공지사항 리스트 페이지 접근 권한 **********/
    path: PATHS.NOTICE_PRODUCT_LIST_URL_PATH,
    resource: 'productNotice',
    permissions: ['readList'],
  },
  {
    /********** 상품 공지사항 상세 페이지 접근 권한 **********/
    path: PATHS.NOTICE_PRODUCT_DETAIL_URL_PATH,
    resource: 'productNotice',
    permissions: ['read'],
  },
  {
    /********** 검색 키워드 리스트  페이지 접근 권한 **********/
    path: PATHS.SEARCH_WORD_LIST_URL_PATH,
    resource: 'searchKeyword',
    permissions: ['readList'],
  },
  {
    /********** 검색 키워드 등록 페이지 접근 권한 **********/
    path: PATHS.SEARCH_WORD_CREATE_URL_PATH,
    resource: 'searchKeyword',
    permissions: ['create'],
  },
  {
    /********** 검색 키워드 편집 페이지 접근 권한 **********/
    path: PATHS.SEARCH_WORD_EDIT_URL_PATH,
    resource: 'searchKeyword',
    permissions: ['read', 'update'],
  },
  {
    /********** 검색 사전 페이지 접근 권한 (AMZUWEB-694) — 동의어 목록이 첫 탭이라 목록 권한 **********/
    path: PATHS.SEARCH_DICTIONARY_URL_PATH,
    resource: 'searchDictionary',
    permissions: ['readList'],
  },
  {
    /**
     * 동의어 규칙 등록 페이지 접근 권한.
     * 🔴 `/:id` 상세보다 **먼저** 둔다 — 첫 매칭을 쓰므로 뒤에 두면 `new` 가 id 로 잡혀 read 권한으로 열린다.
     */
    path: PATHS.SEARCH_DICTIONARY_SYNONYM_CREATE_URL_PATH,
    resource: 'searchDictionary',
    // 등록 화면도 검증·미리보기(read)를 부른다
    permissions: ['create', 'read'],
  },
  {
    /********** 동의어 규칙 상세 페이지 접근 권한 — 백엔드 GET synonyms/:ruleId 가 read **********/
    path: PATHS.SEARCH_DICTIONARY_SYNONYM_DETAIL_URL_PATH,
    resource: 'searchDictionary',
    permissions: ['read'],
  },
  {
    /********** 서버 피처 플래그 페이지 접근 권한 — 백엔드 GET /feature-flags 가 read **********/
    path: PATHS.SYSTEM_FEATURE_FLAG_URL_PATH,
    resource: 'featureFlag',
    permissions: ['read'],
  },
  {
    /********** 1:1 문의 리스트 페이지접근 권한 **********/
    path: PATHS.CS_INQUIRY_LIST_URL_PATH,
    resource: 'oneOnOneInquiry',
    permissions: ['readList'],
  },
  {
    /********** 1:1 문의 상세 페이지 접근 권한 **********/
    path: PATHS.CS_INQUIRY_DETAIL_URL_PATH,
    resource: 'oneOnOneInquiry',
    permissions: ['read'],
  },
  {
    /********** 상품 문의 리스트 페이지 접근 권한 *****기*****/
    path: PATHS.CS_QNA_LIST_URL_PATH,
    resource: 'productInquiry',
    permissions: ['readList'],
  },
  {
    /********** 상품 문의 상세 페이지 접근 권한 **********/
    path: PATHS.CS_QNA_DETAIL_URL_PATH,
    resource: 'productInquiry',
    permissions: ['read'],
  },
  {
    /**********상품 후기 리스트 페이지  접근 권한 **********/
    path: PATHS.CS_REVIEW_LIST_URL_PATH,
    resource: 'review',
    permissions: ['readList'],
  },
  {
    /********** 상품 후기 상세 페이지 접근 권한 **********/
    path: PATHS.CS_REVIEW_DETAIL_URL_PATH,
    resource: 'review',
    permissions: ['read'],
  },
  {
    /********** 상품 후기 등록 페이지 접근 권한 **********/
    path: PATHS.CS_REVIEW_CREATE_URL_PATH,
    resource: 'review',
    permissions: ['create'],
  },
  {
    /********** 버전 전체 리스트 페이지 접근 권한 **********/
    path: PATHS.VERSION_LIST_URL_PATH,
    resource: 'version',
    permissions: ['readList'],
  },
  {
    /********** 버전 등록 페이지 접근 권한 **********/
    path: PATHS.VERSION_CREATE_URL_PATH,
    resource: 'version',
    permissions: ['create'],
  },
  {
    /********** 버전 편집 페이지 접근 권한 **********/
    path: PATHS.VERSION_EDIT_URL_PATH,
    resource: 'version',
    permissions: ['read', 'update'],
  },
  {
    /********** 추천 상품 리스트 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_PRODUCT_LIST_URL_PATH,
    resource: 'recommendProduct',
    permissions: ['readList'],
  },
  {
    /********** 추천 상품 상세 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_PRODUCT_DETAIL_URL_PATH,
    resource: 'recommendProduct',
    permissions: ['read'],
  },
  {
    /********** 추천 상품 복사 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_PRODUCT_COPY_URL_PATH,
    resource: 'recommendProduct',
    permissions: ['create'],
  },
  {
    /********** 추천 상품 등록 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_PRODUCT_CREATE_URL_PATH,
    resource: 'recommendProduct',
    permissions: ['create'],
  },
  {
    /********** 추천 상품 후기 리스트 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_REVIEW_LIST_URL_PATH,
    resource: 'recommendProductReview',
    permissions: ['readList'],
  },
  {
    /********** 추천 상품 후기 상세 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_REVIEW_DETAIL_URL_PATH,
    resource: 'recommendProductReview',
    permissions: ['read'],
  },
  {
    /********** 추천 상품 후기 복사 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_REVIEW_COPY_URL_PATH,
    resource: 'recommendProductReview',
    permissions: ['create'],
  },
  {
    /********** 추천 상품 후기 등록 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_REVIEW_CREATE_URL_PATH,
    resource: 'recommendProductReview',
    permissions: ['create'],
  },
  {
    /********** 추천 태그 리스트 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_TAG_LIST_URL_PATH,
    resource: 'recommendTag',
    permissions: ['readList'],
  },
  {
    /********** 추천 태그 상세 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_TAG_DETAIL_URL_PATH,
    resource: 'recommendTag',
    permissions: ['read'],
  },
  {
    /********** 추천 태그 복사 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_TAG_COPY_URL_PATH,
    resource: 'recommendTag',
    permissions: ['create'],
  },
  {
    /********** 추천 태그 등록 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_TAG_CREATE_URL_PATH,
    resource: 'recommendTag',
    permissions: ['create'],
  },
  {
    /********** 추천 검색 키워드 리스트 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_SEARCH_WORD_LIST_URL_PATH,
    resource: 'recommendSearch',
    permissions: ['readList'],
  },
  {
    /********** 추천 검색 키워드 상세 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_SEARCH_WORD_DETAIL_URL_PATH,
    resource: 'recommendSearch',
    permissions: ['read'],
  },
  {
    /********** 추천 검색 키워드 복사 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_SEARCH_WORD_COPY_URL_PATH,
    resource: 'recommendSearch',
    permissions: ['create'],
  },
  {
    /********** 추천 검색 키워드 등록 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_SEARCH_WORD_CREATE_URL_PATH,
    resource: 'recommendSearch',
    permissions: ['create'],
  },
  {
    /********** 추천 기획전 리스트 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_EVENT_LIST_URL_PATH,
    resource: 'recommendEvent',
    permissions: ['readList'],
  },
  {
    /********** 추천 기획전 상세 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_EVENT_DETAIL_URL_PATH,
    resource: 'recommendEvent',
    permissions: ['read'],
  },
  {
    /********** 추천 기획전 복사 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_EVENT_COPY_URL_PATH,
    resource: 'recommendEvent',
    permissions: ['create'],
  },
  {
    /********** 추천 기획전 등록 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_EVENT_CREATE_URL_PATH,
    resource: 'recommendEvent',
    permissions: ['create'],
  },
  {
    /********** 추천 상점 리스트 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_STORE_LIST_URL_PATH,
    resource: 'recommendStore',
    permissions: ['readList'],
  },
  {
    /********** 추천 상점 상세 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_STORE_DETAIL_URL_PATH,
    resource: 'recommendStore',
    permissions: ['read'],
  },
  {
    /********** 추천 상점 복사 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_STORE_COPY_URL_PATH,
    resource: 'recommendStore',
    permissions: ['create'],
  },
  {
    /********** 추천 상점 등록 페이지 접근 권한 **********/
    path: PATHS.RECOMMEND_STORE_CREATE_URL_PATH,
    resource: 'recommendStore',
    permissions: ['create'],
  },
  {
    path: PATHS.LUCKY_DRAW_URL_PATH,
    resource: 'luckyDraws',
    permissions: [],
  },
];
